import A from 'const/actionTypes'
import actions from 'actions'

export default {
  processCounterStrikeGlobalOffensivePurchase: (purchaseData, response) => {
    return (dispatch, getState) => {
      dispatch(actions.addCSGOToken(purchaseData, response))
      dispatch(actions.alertGamer({ message: 'CS:GO Purchase Successful!', }))
    }
  },
  processDonation: (purchaseData, response) => {
    return (dispatch, getState) => {
      dispatch(actions.addDonationToken(purchaseData, response))
      dispatch(actions.alertGamer({ message: 'Thank You For Your Support!', }))
    }
  },
  processSoundPackPurchase: (purchaseData, response, soundPack) => {
    return (dispatch, getState) => {
      dispatch(actions.addSoundPackToken(purchaseData, response, soundPack))
      dispatch(actions.alertGamer({ message: 'Sound Pack Purchase Successful!', }))
    }
  },
  setCounterStrikeGlobalOffensivePack: (csgoPack) => {
    return (dispatch, getState) => {
      dispatch({
        type: A.SET_COUNTER_STRIKE_GLOBAL_OFFENSIVE_PACK,
        counterStrikeGlobalOffensivePack: csgoPack,
      })
    }
  },
  setDonationAmount: (amount) => {
    return (dispatch, getState) => {
      dispatch({
        type: A.SET_DONATION_AMOUNT,
        donationAmount: amount,
      })
    }
  },
  setSoundPack: (soundPack) => {
    return (dispatch, getState) => {
      dispatch({
        type: A.SET_SOUND_PACK,
        soundPack: soundPack,
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/purchases.js